import {connect} from 'react-redux'
import styles from './PurchaseOrderDetail.css'
import {
  onClickDone,
  onClickPrint,
  onClickResendEmail,
  updatePurchaseOrders,
  onClickEdit
} from 'actions/inventory/purchaseOrder'
import LabelSection from 'components/sections/LabelSection'
import {DropdownButton, MenuItem} from 'react-bootstrap'
import Separator from './Separator'
import moment from 'moment'
import Activities from './Activities'
import PurchaseItemList from './PurchaseItemList'

class PurchaseOrderDetail extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      markAsFulfilledBtnDisabledStatus: false
    }
  }

  render () {
    const {purchaseOrderDetail} = this.props
    let numPhone
    if (purchaseOrderDetail.supplier_phone === null) {
      numPhone = ''
    } else {
      if (purchaseOrderDetail.supplier_phone.charAt(0) === '0') {
        numPhone = replaceNumPhone(purchaseOrderDetail.supplier_phone, 0, '+62')
      } else {
        numPhone = '+62' + purchaseOrderDetail.supplier_phone
      }
    }
    return (<div className={styles.wrapper}>
      <div className={styles.content}>
        <div className='row'>
          <div className='col-sm-12'>
            <div className='pull-right'>
              {(purchaseOrderDetail.status === 'Created' || purchaseOrderDetail.status === 'Updated') && <button className={`btn btn-primary ${styles.buttonFulfilled}`} disabled={this.state.markAsFulfilledBtnDisabledStatus} onClick={this._onClickMarkAsFulfilled}>Mark as Fulfilled</button>}
              <DropdownButton title='More' onSelect={this._onSelectMore} pullRight>
                {purchaseOrderDetail.status !== 'Fulfilled' && purchaseOrderDetail.supplier_email && <MenuItem eventKey='resend_email'>Resend</MenuItem>}
                {purchaseOrderDetail.status !== 'Fulfilled' && purchaseOrderDetail.status !== 'Cancelled' && <MenuItem eventKey='cancel'>Cancel Order <i className={`glyphicon btn btn-danger glyphicon-minus ${styles.icon_cancel}`} /></MenuItem>}
                <MenuItem eventKey='print'>Print</MenuItem>
                {purchaseOrderDetail.status !== 'Fulfilled' && purchaseOrderDetail.status !== 'Cancelled' && <MenuItem eventKey='edit'>Edit</MenuItem>}
              </DropdownButton>
            </div>
          </div>
          <div className='mt-20px col-sm-12'>
            <LabelSection title='Purchase Order Details' />
          </div>
          {purchaseOrderDetail.supplier_id !== 0 && <div className='col-sm-12'>
            <div className={styles['supplier-name']}>{purchaseOrderDetail.supplier_name}</div>
            <table className='table table-bordered'>
              <tbody>
                <tr>
                  <td><div>{numPhone}</div></td>
                  <td colSpan={4}><div> {purchaseOrderDetail.supplier_email}</div></td>
                </tr>
                <tr>
                  <td colSpan={4}>
                    <div className={styles.break}>
                      {purchaseOrderDetail.supplier_address}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className={styles.break}>{purchaseOrderDetail.supplier_city}</div>
                  </td>
                  <td>
                    <div className={styles.break}>{purchaseOrderDetail.supplier_state}</div>
                  </td>
                  <td>
                    <div>{purchaseOrderDetail.supplier_postal_code}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>}
          {purchaseOrderDetail.note && <div className='col-sm-12'>
            <div>Note</div>
            <Separator />
            <div>{purchaseOrderDetail.note}</div>
          </div>}
          <div className='col-sm-12'>
            <Separator />
            <div>PO Number #{purchaseOrderDetail.order_no}</div>
            <div>Created at : {moment(purchaseOrderDetail.created_at).format('MM/DD/YYYY HH:mm')}</div>
            <div>Created by: {purchaseOrderDetail.creator.first_name} {purchaseOrderDetail.creator.last_name}</div>
            {purchaseOrderDetail.updater && <div>Updated by: {purchaseOrderDetail.updater.first_name} {purchaseOrderDetail.updater.last_name}</div>}
            <div>Email: {purchaseOrderDetail.creator.email}</div>
            <div>Outlet Name: {purchaseOrderDetail.outlet.name}</div>
            <div>Phone: {purchaseOrderDetail.outlet.phone_number}</div>
            <div>Address: {purchaseOrderDetail.outlet.address}, {purchaseOrderDetail.outlet.city}, {purchaseOrderDetail.outlet.province}, {purchaseOrderDetail.outlet.postal_code}</div>
          </div>
          <div className='mt-20px col-sm-12'>
            <LabelSection title='Status Activity' />
            <Activities purchaseOrderDetail={purchaseOrderDetail} />
            { purchaseOrderDetail.history_details && <LabelSection title='Purchase Items' />}
            { purchaseOrderDetail.ingredient_history_details && <LabelSection title='Purchase Ingredients' />}
            { purchaseOrderDetail.history_details && <PurchaseItemList total={purchaseOrderDetail.total} detail={purchaseOrderDetail.history_details} /> }
            { purchaseOrderDetail.ingredient_history_details && <PurchaseItemList total={purchaseOrderDetail.total} detail={purchaseOrderDetail.ingredient_history_details} isIngredient='true' /> }
          </div>
        </div>

      </div>
      <div className={styles.footer}>
        <span className='pull-right'>
          <button onClick={this._onClickDone} className='btn btn-primary'>Done</button>
        </span>

      </div>
    </div>)
  }

  _onClickDone = () => {
    const {dispatch} = this.props
    dispatch(onClickDone())
  }

  _onSelectMore = (eventKey, event) => {
    const {dispatch, purchaseOrderDetail} = this.props
    if (eventKey === 'print') {
      dispatch(onClickPrint(purchaseOrderDetail))
    } else if (eventKey === 'resend_email') {
      dispatch(onClickResendEmail(purchaseOrderDetail))
    } else if (eventKey === 'cancel') {
      const {dispatch, purchaseOrderDetail} = this.props
      dispatch(updatePurchaseOrders(purchaseOrderDetail, 'Cancelled'))
    } else if (eventKey === 'edit') {
      dispatch(onClickEdit(purchaseOrderDetail))
    }
  }

  _onClickMarkAsFulfilled = () => {
    this.setState({markAsFulfilledBtnDisabledStatus: true})
    const {dispatch, purchaseOrderDetail} = this.props
    dispatch(updatePurchaseOrders(purchaseOrderDetail, 'Fulfilled'))
  }
}

function replaceNumPhone (stringNumb, index, replacement) {
  return stringNumb.substr(0, index) + replacement + stringNumb.substr(index + replacement.length)
}

function mapStateToProps (state) {
  const {purchaseOrderDetail} = state.inventory.purchaseOrder
  return {purchaseOrderDetail}
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseOrderDetail)



// WEBPACK FOOTER //
// ./app/pages/Inventory/PurchaseOrder/PurchaseOrderDetail/PurchaseOrderDetail.js